import {createContext, useState} from "react";

const AuthContext = createContext({})

export const AuthProvider = ({children}) => {
    const [auth, setAuth] = useState(localStorage.getItem('AudioTimeAuth') && "0");



    return <AuthContext.Provider value={{auth, setAuth }}>{children}</AuthContext.Provider>

}
export default AuthContext